import { AfterViewInit, Component, ElementRef, HostBinding, NgZone, ViewChild, ViewEncapsulation } from '@angular/core';
import { ResolveEmit } from '../../interfaces/resolve-emit';

@Component({
  selector: 'jaspero-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ConfirmationComponent implements AfterViewInit {
  constructor(
    private _ngZone: NgZone
  ) { }

  @HostBinding('class.jaspero__confirmation') true;
  @ViewChild('focus') focusEl: ElementRef;

  animationState = 'enter';
  incomingData: any = {
    title: '',
    titleIsTemplate: false,
    message: '',
    messageIsTemplate: false,
    overlay: true,
    overlayClickToClose: true,
    showCloseButton: true,
    confirmText: 'Yes',
    confirmTextIsTemplate: false,
    declineText: 'No',
    declineTextIsTemplate: false,
    resolve$: null
  };

  ngAfterViewInit() {
    setTimeout(() => {
      this.focusEl.nativeElement.focus();
    }, 100);

    let titleWidth = $('.jaspero__confirmation_dialog-title .jaspero__confirmation_dialog-data').outerWidth() || 0;
    let contentWidth = $('.jaspero__confirmation_dialog-content .jaspero__confirmation_dialog-data').outerWidth() || 0;
    let maxWidth = 600;
    let width = (titleWidth > contentWidth) ? titleWidth : contentWidth;
    width = (width > maxWidth ? maxWidth : width) + 100;
    $('.jaspero__confirmation_dialog').css({ 'width': `${width}px` });
  }

  overlayClick() {
    if (!this.incomingData.overlayClickToClose) {
      return;
    }

    this.close('overlayClick');
  }

  close(type: string) {
    this.animationState = 'leave';
    this._ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this._ngZone.run(() => {
          this.resolve({ closedWithOutResolving: type });
        });
      }, 450);
    });
  }

  resolve(how: ResolveEmit) {
    this.animationState = 'leave';
    this._ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this._ngZone.run(() => {
          this.incomingData.resolve$.next(how);
        });
      }, 450);
    });
  }
}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/ng-confirmations/components/confirmation/confirmation.component.ts